// main.js
import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

export default class BarChart extends React.Component {
    constructor(props) {
        super(props);
    }

    renderH2H() {
        let { values, total, width, height, type, title, valLabelPosition, animation } = this.props;
        height = height || width;
        if (!values || values.length != 2) return;

        total = total || _.reduce(values, (sum, v) => sum + v[0], 0);
        if (total == 0) total = 1;
        var val1perc = (values[0][0] * 100) / total / 2;
        var val2perc = (values[1][0] * 100) / total / 2;

        return (
            <div className={cx('wdp-bar-chart', 'wdp-bar-chart__' + type)}>
                {title && <div className="wdp-bar-chart__title">{title}</div>}
                <div
                    className={cx(
                        'wdp-bar-chart__bar',
                        `wdp-bar-chart__bar__${type}`,
                        `wdp-bar-chart__bar__${valLabelPosition}`
                    )}
                >
                    {values[0][1] !== undefined && (
                        <label className="wdp-bar-chart__label wdp-bar-chart__label-home">{values[0][1]}</label>
                    )}
                    {values[1][1] !== undefined && (
                        <label className="wdp-bar-chart__label wdp-bar-chart__label-away">{values[1][1]}</label>
                    )}
                    <svg width={width} height={height}>
                        <rect key={val1perc + '_1'} className={cx('wdp-bar', 'wdp-bar-0')} height="100%">
                            {animation && (
                                <animate
                                    attributeName="width"
                                    from={0}
                                    to={val1perc + '%'}
                                    dur={(1000 * val1perc) / 100 + 'ms'}
                                    begin="300ms"
                                    fill="freeze"
                                />
                            )}
                            {animation && (
                                <animate
                                    attributeName="x"
                                    from={50 + '%'}
                                    to={50 - val1perc + '%'}
                                    dur={(1000 * val1perc) / 100 + 'ms'}
                                    begin="300ms"
                                    fill="freeze"
                                />
                            )}
                        </rect>
                        <rect key={val2perc + '_2'} x="50%" className={cx('wdp-bar', 'wdp-bar-1')} height="100%">
                            {animation && (
                                <animate
                                    attributeName="width"
                                    from={0}
                                    to={val2perc + '%'}
                                    begin="300ms"
                                    dur={(1000 * val2perc) / 100 + 'ms'}
                                    fill="freeze"
                                />
                            )}
                        </rect>
                    </svg>
                </div>
            </div>
        );
    }

    renderDefaultBars() {
        let { values, total, width, height, type, title, animation } = this.props;
        height = height || width;
        total = _.reduce(values, (sum, v) => sum + v[0], 0);

        return (
            <div className={cx('wdp-bar-chart', 'wdp-bar-chart-' + type)}>
                {title && <div className="wdp-bar-chart__title">{title}</div>}
                <div className={cx('wdp-bar-chart__bar', `wdp-bar-chart__bar__${type}`)}>
                    <svg width={width} height={height}>
                        {values.map((item, i) => {
                            var left = _.chain(values)
                                .take(i)
                                .reduce((sum, v) => sum + v[0], 0)
                                .value();
                            var barWidth = (item[0] * 100) / total || 0;

                            return [
                                <rect
                                    key={i}
                                    x={!total ? '0%' : (left * 100) / total + '%'}
                                    className={cx('wdp-bar', 'wdp-bar-' + i)}
                                    width={`${barWidth}%`}
                                    height="100%"
                                >
                                    {animation && (
                                        <animate
                                            attributeName="width"
                                            from={0}
                                            to={`${barWidth}%`}
                                            dur={(800 * barWidth) / 100 + 'ms'}
                                            begin={300 + (800 * left) / 100 + 'ms'}
                                            fill="freeze"
                                        />
                                    )}
                                </rect>,
                                item[1] !== undefined && (
                                    <text
                                        key={i + 'lbl'}
                                        x={!total ? '0' : (left * 100) / total + '%'}
                                        y="50%"
                                        dy=".35em"
                                        dx=".35em"
                                        fill="#fff"
                                    >
                                        {item[1]}
                                    </text>
                                )
                            ];
                        })}
                    </svg>
                </div>
            </div>
        );
    }

    render() {
        switch (this.props.type) {
            case 'h2h':
                return this.renderH2H();
                break;
            default:
                return this.renderDefaultBars();
        }
    }
}
BarChart.defaultProps = {
    width: '100%',
    height: 18,
    valLabelPosition: 'outside',
    animation: true,
    values: [[33, '33%'], [33, '33%'], [33, '33%']],
    type: 'default'
};



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/BarChart.js
 **/